import { PriceInterval } from '@griply/types';
import { useMemo } from 'react';
import { useSubscriptionPricesQuery } from 'shared/hooks/queries/use-subscription-prices-query';
import { useUser } from 'shared/hooks/use-user';
import { getUserHasSubscription } from 'shared/utils/get-user-has-subscription';

export const useSubscriptionPrices = () => {
  const user = useUser();
  const { data } = useSubscriptionPricesQuery(user?.uid);

  return useMemo(
    () =>
      data
        ? {
            ...data,
            prices: getUserHasSubscription(user)
              ? data.prices.filter(
                  ({ interval }) =>
                    ![PriceInterval.Year, PriceInterval.Month].includes(
                      interval,
                    ),
                )
              : data.prices,
          }
        : { prices: [], discount: null },
    [data, user],
  );
};
